// src/store/features/pollSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface PollState {
  lastPollTime: number;
  storeStatus: {
    isOpen: boolean;
    reason: "operating-hours" | "manual-closure" | "open";
  };
}

const initialState: PollState = {
  lastPollTime: Date.now(),
  storeStatus: {
    isOpen: true,
    reason: "open",
  },
};

export const pollSlice = createSlice({
  name: "poll",
  initialState,
  reducers: {
    updateStoreStatus: (
      state,
      action: PayloadAction<{
        isOpen: boolean;
        reason: "operating-hours" | "manual-closure" | "open";
      }>,
    ) => {
      if (
        state.storeStatus.isOpen !== action.payload.isOpen ||
        state.storeStatus.reason !== action.payload.reason
      ) {
        state.storeStatus = action.payload;
      }
    },
    updateLastPollTime: (state) => {
      state.lastPollTime = Date.now();
    },
  },
});

export const { updateStoreStatus, updateLastPollTime } = pollSlice.actions;
export default pollSlice.reducer;
